/**
 * Detect content type from text.
 */

import includes from 'lodash/includes'
import replace from 'lodash/replace'
import split from 'lodash/split'
import startsWith from 'lodash/startsWith'
import toLower from 'lodash/toLower'
import toString from 'lodash/toString'
import trim from 'lodash/trim'

import { isBase64Image, isInlineDataImage } from 'utils/Image'
import { allowedCustomProtocols } from 'utils/url'

export const CONTENT_TYPE_EMPTY = 'CONTENT_TYPE_EMPTY'
export const CONTENT_TYPE_HTML = 'CONTENT_TYPE_HTML'
export const CONTENT_TYPE_YOUTUBE = 'CONTENT_TYPE_YOUTUBE'
export const CONTENT_TYPE_IMAGE = 'CONTENT_TYPE_IMAGE'
export const CONTENT_TYPE_URL = 'CONTENT_TYPE_URL'
export const CONTENT_TYPE_UNKNOWN = 'CONTENT_TYPE_UNKNOWN'

// Note the order of these lookups is critical. For example, putting a check for a url after http:// will never trigger.
const ContentType = function (textRaw) {
  textRaw = trim(toString(textRaw))
  const textLower = toLower(toString(textRaw))

  if (textLower === '') {
    return CONTENT_TYPE_EMPTY
  }

  // Naive check if content is HTML
  if (textRaw.match(/^<[a-z]+/i)) {
    // console.debug('ContentType - HTML', textRaw)

    return CONTENT_TYPE_HTML
  }

  if (includes(textLower, 'youtube.com') && includes(textLower, 'watch?') && !includes(textLower, 'channel')) {
    return CONTENT_TYPE_YOUTUBE
  }

  /* if (includes(textLower, '.pdf')) {
    return CONTENT_TYPE_PDF
  } */

  // Detect images
  if ((textLower.startsWith('https://') || textLower.startsWith('http://')) && (
    includes(textLower, 'export=view') || // Google drive image
    includes(textLower, '.jpg') ||
    includes(textLower, '.jpeg') ||
    includes(textLower, '.png') ||
    includes(textLower, '.gif') ||
    includes(textLower, '.svg') ||
    includes(textLower, 'streetview'))
  ) {
    return CONTENT_TYPE_IMAGE
  }

  // Detect base64 encoded inline images
  if (isBase64Image(textLower) || isInlineDataImage(textLower)) {
    return CONTENT_TYPE_IMAGE
  }

  // Check this last or will return this type instead of image or youtube.
  if (
    startsWith(textLower, 'https://') ||
    startsWith(textLower, 'http://') ||
    startsWith(textLower, 'www.') ||

    // Any text starting with one of the allowed custom protocols is a URL
    Object.keys(allowedCustomProtocols).some((protocol) => startsWith(textLower, protocol))
  ) {
    return CONTENT_TYPE_URL
  }

  /*
  if (includes(textLower, ';')) {
    return CONTENT_TYPE_LIST
  } */

  return CONTENT_TYPE_UNKNOWN
}

export function getURLLabel (url) {
  let label = url
  label = replace(label, 'https://', '')
  label = replace(label, 'http://', '')
  label = replace(label, 'https', '')
  label = replace(label, 'http', '')
  label = replace(label, 'www.', '')
  if (label.length > 30) {
    label = label.substring(0, 30) + '...'
  }
  return label
}

export function getGooglePDFViewerIFrameSrc (url) {
  return 'https://drive.google.com/viewerng/viewer?url=' + encodeURIComponent(url) + '&embedded=true'
}

// URL like: https://www.youtube.com/watch?v=rApnLxzE-Ys
export function getYoutubeIFrameSrc (url, bWithOrigin) {
  if (!bWithOrigin) {
    bWithOrigin = true
  }
  let youtubeVideoID = ''
  const sParam = 'v'
  const sParams = split(url, '?')
  if (sParams.length < 2) {
    console.log('getYoutubeURL invalid URL. Missing ?')
    return ''
  }
  const sURLVariables = split(sParams[1], '&')
  for (let i = 0; i < sURLVariables.length; i++) {
    const sParameterName = sURLVariables[i].split('=')
    if (sParameterName[0] === sParam) {
      youtubeVideoID = sParameterName[1]
      break
    }
  }
  if (youtubeVideoID === '') {
    console.log('Unable to find the v param on the Youtube url from text:', url)
    return ''
  }
  // Building an iframe to embed the video
  let youtubeURL = 'https://www.youtube.com/embed/' + youtubeVideoID
  if (bWithOrigin) {
    youtubeURL += '?origin=http://www.pozi.com'
  }
  return youtubeURL
}

export default ContentType
